"use client";
import { useState, useEffect } from "react";
import MapView from "@components/CustomComponents/LocatorStore/Map";
import styles from "@components/CustomComponents/LocatorStore/SearchResult/index.module.scss";
import { useDeviceType } from "@/hooks/useDeviceType";
import Tooltip from "@/components/ToolTip";

export default function SearchResult(props) {
  const {
    searchText = "",
    result = [],
    location = {},
    selected = [],
    showResults,
  } = props;

  const { results = [], __count = 0 } = result?.d || {};

  const [resultCount, setResultCount] = useState(__count);

  const [searchResults, setSearchResults] = useState(results);

  const [locationResult, setLocationResult] = useState([]);

  const [showPopup, setShowPopup] = useState(false);

  const [markerData, setMarkerData] = useState([]);

  const { isMobile } = useDeviceType();

  const [activeTab, setActiveTab] = useState("list");

  useEffect(() => {
    const latLongData = results.map(store => ({
      lat: store.Latitude,
      lng: store.Longitude,
    }));
    setLocationResult(latLongData);
    setSearchResults(results);
  }, [location]);

  useEffect(() => {
    const filteredResults = results.filter(item =>
      selected.includes(item.ContactClassification)
    );
    let filteredData = [];

    if (markerData && markerData.length > 0) {
      filteredData = markerData.filter(item =>
        selected.includes(item.ContactClassification)
      );
    }
    const latLongData = filteredResults.map(store => ({
      lat: store.Latitude,
      lng: store.Longitude,
    }));
    setLocationResult(latLongData);
    setSearchResults(filteredResults);
    setMarkerData(filteredData);
  }, [selected]);

  useEffect(() => {
    setResultCount(searchResults.length);
    const latLongData = searchResults.map(store => ({
      lat: store.Latitude,
      lng: store.Longitude,
    }));
    setLocationResult(latLongData);
  }, [searchResults]);

  useEffect(() => {
    if (resultCount <= 0) {
      setShowPopup(false);
    } else {
      setShowPopup(true);
    }
  }, [resultCount]);

  const checkResultCount = () => {
    if (isMobile && resultCount <= 0) {
      setActiveTab("map");
    }
  };

  const getMarkerPopUp = (store, id) => {
    setShowPopup(true);
    let data = { ...store, id: id };
    setMarkerData(data);
  };
  const wrapperClass = resultCount > 0 ? "resultWrapper" : "noResultWrapper";

  const showMap = activeTab === "map" || (resultCount <= 0 && isMobile);

  return (
    <div className={styles.wrapper}>
      <div className={`${wrapperClass}`}>
        <div className="mb-4 text-center">
          {resultCount > 0 ? (
            <h3 className="count-results">
              {resultCount} results for {searchText}.
            </h3>
          ) : (
            <div className="koh-no-result">
              <p className="text-center-info font-extrabold text-3xl text-[#000] text-center mt-10 mb-5">
                We are sorry, but we have no stores within 400 Kilometers of
                your location. Please try another search.
              </p>
            </div>
          )}
        </div>
        {isMobile ? (
          <div className="flex mb-7">
            <button
              className={`px-4 py-2  text-white  list-tab ${activeTab === "list" ? "tab-active" : "tab-inactive"}`}
              onClick={() => {
                setActiveTab("list");
              }}
            >
              <label className="text-[#000]">LIST</label>
            </button>
            <button
              className={`px-4 py-2  text-white  map-tab ${activeTab === "map" ? "tab-active" : "tab-inactive"}`}
              onClick={() => setActiveTab("map")}
            >
              <label className="text-[#000]">MAP</label>
            </button>
          </div>
        ) : null}

        <div className="flex flex-col md:flex-row gap-4 w-full">
          {/* STORE LIST */}
          {resultCount > 0 ? (
            <div
              className={`md:w-1/3  cursor-pointer space-y-4 result-list h-[700px] overflow-y-auto  ${activeTab === "list" ? "block" : "hidden"} md:block`}
            >
              {searchResults.map((store, index) => (
                <div
                  key={index + 1}
                  className={`mb-0 hover:bg-[#F8F8F8] active:bg-[#D3D3D3] transition-colors duration-300 div-${store.ContactClassification}`}
                  onClick={() => getMarkerPopUp(store, index + 1)}
                >
                  <div className="w-full p-[15px]">
                    <h3 className="font-semibold flex items-center gap-2">
                      <span
                        className={`${store.ContactClassification} text-white w-6 h-6 flex items-center justify-center text-sm`}
                      >
                        {index + 1}
                      </span>
                      <span className="store-name">{store.LocationName}</span>
                    </h3>

                    <div className="text-sm ml-8">
                      <p className="para-font">
                        {store.AddressLine} {store.Locality}
                      </p>
                      {store.Phone ? (
                        <p className="text-sm mt-1 para-font">
                          {store.Phone}{" "}
                          {store.WebURL ? (
                            <>
                              {" "}
                              |{" "}
                              <a
                                href={store.WebURL}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="text-blue-500 hover:underline"
                              >
                                Visit Website
                              </a>
                            </>
                          ) : null}
                        </p>
                      ) : null}
                    </div>
                    <div className="koh-store-locator-result-distance text-sm text-[#000] font-bold mt-5 flex justify-end">
                      {" "}
                      {store.__Distance?.toFixed(2)} KM
                    </div>
                  </div>
                </div>
              ))}
            </div>
          ) : null}

          {/*  MAP */}
          <div
            className={`${resultCount > 0 ? "w-full md:w-2/3" : "w-full"} h-[700px] bg-gray-200 rounded-xl flex items-center justify-center
                           ${showMap ? "block" : "hidden"} md:block`}
          >
            {showResults && markerData ? (
              <MapView
                locationResult={locationResult}
                selected={selected}
                location={location}
                showPopup={showPopup}
                setShowPopup={setShowPopup}
                markerData={markerData}
              />
            ) : null}
          </div>
        </div>

        {/* LEGEND */}
        <div
          className={`mt-6 flex flex-wrap gap-6 justify-start md:justify-end md:mr-14 ${activeTab === "list" && isMobile ? "hidden" : "block"}`}
        >
          <Legend color="bg-[#84A648]" label="Kohler Experience Center" />
          <Legend color="bg-[#00a7ce]" label="KOHLER Showroom" />
          <Legend color="bg-[#9d9d9d]" label="Authorized KOHLER dealer" />
        </div>
      </div>
    </div>
  );
}

function Legend({ color, label }) {
  return (
    <div className="flex items-center gap-2">
      <span className={`w-4 h-4  ${color}`}></span>
      <Tooltip text={label} showArrow={true}>
        <span className="text-sm koh-dotted-span">{label}</span>
      </Tooltip>
    </div>
  );
}
